import { jsx as _jsx } from "react/jsx-runtime";
import StarIcon from '@heroicons/react/solid/StarIcon';
import clsx from 'clsx';
export const RatingView = ({ value }) => {
    if (!value) {
        return null;
    }
    return (_jsx("div", { className: "flex", children: [1, 2, 3, 4, 5].map(val => {
            return (_jsx(StarIcon, { className: clsx('w-6 h-6 -me-1', val <= value
                    ? 'text-action-primary'
                    : 'text-content-subdued opacity-50') }, val));
        }) }, void 0));
};
//# sourceMappingURL=RatingView.js.map